import { useCallback } from 'react';
import { IGetByFilterResponse, IListParams } from '@tacans/shared-marketplace-layer';
import { PayloadAction } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from 'src/hooks/app';
import { useFetchDataForNftCards } from 'src/features/common/collection/hooks/use-fetch-data-for-nft-cards';
import { actions } from '../ducks/trending-nfts/trending-nfts.slice';
import { selectBannerNftsEntities, selectBannerNftsLoading } from '../ducks/banner-nfts/banner-nfts.selectors';
import { bannerNftsFetchThunk } from '../ducks/banner-nfts/banner-nfts.thunk';

export const useBannerNfts = () => {
    const dispatch = useAppDispatch();
    const fetchDataForCards = useFetchDataForNftCards();

    const bannerNfts = useAppSelector(selectBannerNftsEntities);
    const isLoading = useAppSelector(selectBannerNftsLoading);

    const fetch = useCallback(async(request: IListParams) => {
        const { payload } = await dispatch(bannerNftsFetchThunk(request)) as PayloadAction<IGetByFilterResponse>;
        if (payload.list) {
            fetchDataForCards(payload.list);
        }
    }, [dispatch, fetchDataForCards]);

    const clear = useCallback(() => {
        dispatch(actions.clear());
    }, [dispatch]);

    return { fetch, clear, bannerNfts, isLoading };
};
